module.exports = __webpack_public_path__ + "img/home_img1.6a1b7948.png";